import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import api from '@/utils/api';
import Header from '@/components/Header';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import dayjs from 'dayjs';

const MyPurchasesPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/auth');
      return;
    }
    fetchPurchases();
  }, [isAuthenticated]);

  const fetchPurchases = async () => {
    try {
      const res = await api.get('/my-purchases');
      setPurchases(res.data);
    } catch (error) {
      toast.error('Erreur lors du chargement de vos achats');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (videoId) => {
    try {
      const res = await api.get(`/downloads/${videoId}`, { responseType: 'blob' });
      
      // Créer un lien de téléchargement
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `video_${videoId}.mp4`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      toast.success('📥 Téléchargement démarré !');
    } catch (error) {
      toast.error('Erreur lors du téléchargement');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="animate-spin text-[#E50914]" size={48} />
      </div>
    );
  }

  return (
    <div className="min-h-screen pb-12">
      <Header />
      
      <main className="pt-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl font-bold mb-8" style={{ fontFamily: 'Outfit' }}>
          Mes achats
        </h1>

        {purchases.length === 0 ? (
          <Card className="glass border-zinc-800 p-12 text-center">
            <p className="text-zinc-400 mb-4">Vous n'avez pas encore acheté de vidéos</p>
            <Button onClick={() => navigate('/')} className="bg-[#E50914] hover:bg-[#F8212C]">
              Découvrir les clips
            </Button>
          </Card>
        ) : (
          <div className="space-y-4">
            {purchases.map((purchase) => (
              <Card key={purchase.id} className="glass border-zinc-800 p-6">
                <div className="flex flex-col md:flex-row md:items-center justify-between space-y-4 md:space-y-0">
                  <div>
                    <h3 className="text-xl font-semibold mb-1">{purchase.video_title}</h3>
                    <p className="text-zinc-400 text-sm">
                      Acheté le {dayjs(purchase.purchase_date).format('DD/MM/YYYY à HH:mm')}
                    </p>
                  </div>
                  <Button
                    onClick={() => handleDownload(purchase.video_id)}
                    className="bg-[#E50914] hover:bg-[#F8212C]"
                  >
                    <Download className="mr-2" size={18} />
                    📥 Télécharger MP4
                  </Button>
                </div>
                <p className="text-xs text-zinc-500 mt-4">
                  ✓ Vidéo avec filigrane personnalisé AGRP BOX
                </p>
              </Card>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default MyPurchasesPage;